import React, { useEffect, useState } from "react";
import KpiTile, { KpiStrip } from "../AgentAnalytics/KpiTile";
import { fetchAnalytics } from "./adTemplateApi";
import { int, share } from "./formatters";

export default function PublicFunnel({ range, refreshKey, totals, totalsLoading }) {
  const [summary, setSummary] = useState({ loading: true, data: null });

  useEffect(() => {
    let alive = true;
    setSummary((s) => ({ ...s, loading: true }));
    fetchAnalytics("public-leads/summary", { from: range.from, to: range.to }).then(
      (r) => alive && setSummary({ loading: false, data: r.data })
    );
    return () => {
      alive = false;
    };
  }, [range.from, range.to, refreshKey]);

  const s = summary.data || {};
  const ofLeads = (count) => {
    const pct = share(count, s.leads);
    return pct ? `${pct} of leads` : null;
  };

  return (
    <KpiStrip testid="public-funnel">
      <KpiTile
        icon="users"
        label="Leads"
        value={int(s.leads)}
        sub="filled the form"
        loading={summary.loading}
        testid="funnel-leads"
      />
      <KpiTile
        icon="check"
        label="Verified"
        value={int(s.verified)}
        sub={ofLeads(s.verified)}
        loading={summary.loading}
        testid="funnel-verified"
      />
      <KpiTile
        icon="layout-grid"
        label="Generated"
        value={int(s.generated)}
        sub={totals ? `${int(totals.adsDelivered)} ads made` : ofLeads(s.generated)}
        loading={summary.loading || totalsLoading}
        testid="funnel-generated"
      />
      <KpiTile
        icon="send"
        label="Carousel sent"
        value={int(s.carouselSent)}
        sub={ofLeads(s.carouselSent)}
        loading={summary.loading}
        testid="funnel-carousel"
      />
      <KpiTile
        icon="star"
        label="Signed up"
        tone="green"
        value={int(s.signedUp)}
        sub={ofLeads(s.signedUp)}
        loading={summary.loading}
        testid="funnel-signed-up"
      />
    </KpiStrip>
  );
}
